<template>
  <q-popup-proxy
    ref="popupproxy"
    @before-show="show">
    <q-card>


      <q-tabs :value="modifiedFilter.type" @input="v => changeTab(v)" class="bg-primary text-white " outside-arrows mobile-arrows>
        <q-tab label="Brand" name="brand" />
        <q-tab label="Colour" name="colour" />
        <q-tab label="Price" name="price" />
        <q-tab label="Material" name="material" />
<!--        <q-tab label="Size" name="size" />-->
        <q-tab label="Type" name="type" />
<!--        <q-tab label="Grip" name="grip" />-->
      </q-tabs>

      <q-tab-panels :value="modifiedFilter.type" animated>
        <q-tab-panel name="brand">
          <div class="q-gutter-sm">
            <q-checkbox v-model="modifiedFilter.values" val="360" label="360" />
            <q-checkbox v-model="modifiedFilter.values" val="AIX" label="AIX" />
            <q-checkbox v-model="modifiedFilter.values" val="Cheeta" label="Cheeta" />
            <q-checkbox v-model="modifiedFilter.values" val="Dimension" label="Dimension" />
          </div>
          <div class="q-gutter-sm">
            <q-checkbox v-model="modifiedFilter.values" val="Elevation" label="Elevation" />
            <!-- <q-checkbox v-model="modifiedFilter.values" val="Escape" label="Escape" /> -->
            <q-checkbox v-model="modifiedFilter.values" val="Flathold" label="Flathold" />
            <!-- <q-checkbox v-model="modifiedFilter.values" val="Friction" label="Friction" /> -->
            <q-checkbox v-model="modifiedFilter.values" val="Grizzly" label="Grizzly" />
            <q-checkbox v-model="modifiedFilter.values" val="ICP" label="ICP" />
          </div>
          <div class="q-gutter-sm">
            <!-- <q-checkbox v-model="modifiedFilter.values" val="Fusion" label="Fusion" /> -->
            <q-checkbox v-model="modifiedFilter.values" val="Kilter" label="Kilter" />            
            <q-checkbox v-model="modifiedFilter.values" val="Kingdom" label="Kingdom" />
            <q-checkbox v-model="modifiedFilter.values" val="Perfect Descent" label="Perfect Descent" />
            <q-checkbox v-model="modifiedFilter.values" val="Satellite" label="Satellite" />
          </div>
          <div class="q-gutter-sm"> 
            <q-checkbox v-model="modifiedFilter.values" val="Simpl" label="Simpl" />            
            <q-checkbox v-model="modifiedFilter.values" val="Tension" label="Tension" />           
            <q-checkbox v-model="modifiedFilter.values" val="Urban Plastix" label="Urban Plastix" />
            <q-checkbox v-model="modifiedFilter.values" val="VolX" label="VolX" />
          </div>
          <div class="q-gutter-sm"> 
            <q-checkbox v-model="modifiedFilter.values" val="Working Class" label="Working Class" />
          </div>          
        </q-tab-panel>

        <q-tab-panel name="colour" style="height: 50vh;">
          <q-btn v-if="currentAccount" class="flex-center full-width" dense flat outlined @click="setFavouriteColoursFilter"
                 label="Set To Favourite Colours"/>
          <q-scroll-area style="height: 43vh;">
            <q-list bordered class="rounded-borders">
              <q-expansion-item
                bordered
                :value="superGroupsInitiallyOpened[superGroup.name]"
                :content-inset-level="0.5"
                v-for="superGroup in colourSuperGroups" :key="superGroup.name">
                <template v-slot:header>
                  <q-item-section avatar>
                    <q-icon :style="{border: '1px silver solid', backgroundColor: superGroup.hex}" name=" " size="md"/>
                  </q-item-section>
                  {{superGroup.name}}
                  <div class="inline-block full-width"></div>
                </template>
                  <q-expansion-item
                    :content-inset-level="0.5"
                    bordered
                    v-for="group in superGroup.groups" :key="group.name" >
                    <template v-slot:header style="width: 100%">
                      <q-item-section avatar>
                        <q-icon :style="{border: '1px silver solid', backgroundColor: group.hex}" name=" " size="md"/>
                      </q-item-section>
                      <q-checkbox :value="colourGroupValue(group.name)" :val="group.name" :label="group.name"
                                  @input="updateColourGroup(group)"/>
                    </template>
                    <q-card>
                      <q-card-section v-for="colour in group.colours" :key="colour.name">
                        <q-item-section avatar class="inline-block q-ml-lg">
                          <q-icon :style="{border: '1px silver solid', backgroundColor: colour.hex}" name=" " size="md"/>
                        </q-item-section>
                        <q-checkbox :value="!!(modifiedFilter.values||[]).find(c => c.name === colour.name)" :label="colour.name"
                                    @input="updateColourSelection(colour)" />
                      </q-card-section>
                    </q-card>
                  </q-expansion-item>
              </q-expansion-item>
            </q-list>
          </q-scroll-area>
        </q-tab-panel>

        <q-tab-panel name="price">
          <div class="q-mt-md q-px-lg" v-if="(modifiedFilter.values || []).length && !(modifiedFilter.values[0].min === undefined)">
            <q-range
              v-model="modifiedFilter.values[0]"
              :min="0"
              :max="1500"
              :step="10"
              :left-label-value="'$' + modifiedFilter.values[0].min || 0"
              :right-label-value="'$' + modifiedFilter.values[0].max || 0"
              label-always
            />
          </div>
          <div class="row q-px-md justify-center" v-if="(modifiedFilter.values || []).length && !(modifiedFilter.values[0].min === undefined)">
            <div class="col-4">
              <q-input
                v-model.number="modifiedFilter.values[0].min"
                type="number"
                label="min"
              />
            </div>
            <div class="col-2"></div>
            <div class="col-4">
              <q-input
                v-model.number="modifiedFilter.values[0].max"
                type="number"
                label="max"
              />
            </div>
          </div>
        </q-tab-panel>

        <q-tab-panel name="material">
          <div class="q-gutter-sm">
            <q-checkbox v-for="material in materials" v-model="modifiedFilter.values" :val="material" :label="material" :key="material" />
          </div>
        </q-tab-panel>

        <q-tab-panel name="size">
          <div class="q-gutter-sm">
            <q-checkbox v-for="size in sizes" v-model="modifiedFilter.values" :val="size" :label="size" :key="size" />
          </div>
        </q-tab-panel>

        <q-tab-panel name="type">
          <div class="q-gutter-sm">
            <q-checkbox v-for="type in types.slice(0, 4)" v-model="modifiedFilter.values" :val="type" :label="type" :key="type" />
          </div>
          <div class="q-gutter-sm">
            <q-checkbox v-for="type in types.slice(4)" v-model="modifiedFilter.values" :val="type" :label="type" :key="type" />
          </div>
        </q-tab-panel>

        <q-tab-panel name="grip">
          <div class="q-gutter-sm">
            <q-checkbox v-for="grip in grips" v-model="modifiedFilter.values" :val="grip" :label="grip" :key="grip" />
          </div>
        </q-tab-panel>
      </q-tab-panels>

      <q-card-actions align="right">
        <q-btn @click="deleteAndClose" flat v-if="!addingNew">Delete</q-btn>
        <q-btn flat v-close-popup>Cancel</q-btn>
        <q-btn flat color="primary" :disabled="disableSaveButton" @click="saveAndClose">Save</q-btn>
      </q-card-actions>
    </q-card>
  </q-popup-proxy>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import store from '../store'


export default {
  name: 'ProductFilterPopup',
  props: ['filterType', 'addNew'],
  data () {
    return {
      superGroupsInitiallyOpened: [],
      modifiedFilter: {},
      materials: [
        'PU',
        'PE',
        'Dannomond',
        'Fiberglass',
        'Wood'
      ],
      sizes: ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL'],
      grips: [
        'Crimp',
        'Sloper',
        'Pinch',
        'Pocket',
        'Footer',
        'Jug',
        'Volume'
      ],
      types: [
        'Hold',
        'Macro',
        'Wooden Volume',
	'ICP Home',
        'Setting Hardware',
        'Training Products',
        'Climbing Equipment',
	'Kids'
      ]
    }
  },
  computed: {
    ...mapState('auth', ['currentAccount']),
    ...mapGetters('filters', ['colourSuperGroups', 'colourGroups']),
    addingNew () {
      return !this.filter
    },
    filter () {
      return this.findFilter(this.modifiedFilter?.type)
    },
    disableSaveButton () {
      const values = this.modifiedFilter.values
      return (this.modifiedFilter.type === 'price' && values?.[0]?.min === 0 && values?.[0]?.max === 1500)
    },
    currentAccount () {
      return store.state.auth.currentAccount
    },
  },
  methods: {
    setFavouriteColoursFilter () {
      const colours = this.$store.state.filters.colours.filter(colour => this.currentAccount.colourFavourites.includes(colour.name))
      if (!colours.length) return
      this.$store.commit('filters/addOrUpdateFilterByType', {
        filter: {
          type: 'colour',
          values: colours
        }
      })
      analytics.track('Set Favourite Colours')
    },
    updateColourGroup (colourGroup) {
      const groupVal = this.colourGroupValue(colourGroup.name)
      if (groupVal) {
        // Clear all
        colourGroup.colours.forEach((v) => this.setColourSelection(v, false))
      } else {
        // Set all
        colourGroup.colours.forEach((v) => this.setColourSelection(v, true))
      }
    },
    colourGroupValue (groupName) {
      // Are ALL items of group groupName in $store.state.filters.colours ?
      const group = this.colourGroups.find(group => group.name === groupName)

      const allSelected = group.colours.every((colour) => {
        // Check if this colour is in the selected colours
        return !!(this.modifiedFilter.values || []).find(c => c.name === colour.name)
      })
      const oneSelected = group.colours.some((colour) => {
        // Check if this colour is in the selected colours
        return !!(this.modifiedFilter.values || []).find(c => c.name === colour.name)
      })

      // Return the value
      if (allSelected) return true
      if (oneSelected) return null
      return false
    },
    updateColourSelection (colour) {
      // Toggle selection
      this.setColourSelection(colour, !this.getColourSelectionValue(colour))
    },
    getColourSelectionValue (colour) {
      return !!(this.modifiedFilter.values || []).find(c => c.name === colour.name)
    },
    setColourSelection (colour, value) {
      // Sets the value without duplicating existing value
      const currentValue = this.getColourSelectionValue(colour)
      if (value && !currentValue) {
        this.modifiedFilter.values.push(colour)
      } else if (!value && currentValue) {
        const index = (this.modifiedFilter.values || []).findIndex(c => c.name === colour.name)
        if (index === -1) return
        this.modifiedFilter.values.splice(index, 1)
      }
    },
    changeTab (filterType) {
      this.save()
      this.selectFilterBeingModified(filterType)
    },
    filterHasValue (type) {
      return !!this.findFilter(type)
    },
    getNewType () {
      return this.$store.state.filters.filterTypes.find(t => !this.filterHasValue(t))
    },
    findFilter (filterType) {
      return this.$store.state.filters.filters.find(f => f.type === filterType)
    },
    selectFilterBeingModified (filterType) {
      let tmpFilter = {}
      if (this.findFilter(filterType)) {
        tmpFilter = JSON.parse(JSON.stringify(this.findFilter(filterType))) // To clone the object
        if (tmpFilter.type === 'price') tmpFilter.values = [tmpFilter.values]
      } else {
        tmpFilter.type = filterType
        if (tmpFilter.type === 'price') {
          tmpFilter.values = [{ min: 0, max: 1500 }]
        } else {
          tmpFilter.values = []
        }
      }
      this.modifiedFilter = tmpFilter

      if (this.modifiedFilter.type === 'colour') {

        this.superGroupsInitiallyOpened = Object.assign({}, ...Object.keys(this.colourSuperGroups).map(k => ({ [this.colourSuperGroups[k].name]: this.colourSuperGroups[k].groups?.some(group => this.colourGroupValue(group.name)) })))
        // this.superGroupsInitiallyOpened = this.colourSuperGroups.map(superGroup => superGroup.groups?.some(group => this.colourGroupValue(group.name)))
      }
    },
    show () {
      this.selectFilterBeingModified(this.filterType || this.getNewType())
    },
    saveAndClose () {
      this.save()
      this.$refs.popupproxy.hide()
    },
    save () {
      let values = this.modifiedFilter.values
      if (!values.length ||
        (this.modifiedFilter.type === 'price' && values?.[0]?.min === 0 && values?.[0]?.max === 1500)) {
        this.deleteFilter()
        return
      }

      if (this.modifiedFilter.type === 'price') {
        values = this.modifiedFilter.values[0]
      }
      this.$store.commit('filters/addOrUpdateFilterByType', {
        filter: {
          type: this.modifiedFilter.type,
          values
        }
      })
      analytics.track('Filter Used', {
        storeType: this.$store.state.cart.currentStoreType,
        type: this.modifiedFilter.type,
        values: values
      })      
    },
    deleteAndClose () {
      this.deleteFilter()
      this.$refs.popupproxy.hide()
    },
    deleteFilter () {
      this.$store.commit('filters/removeFilter', this.filter)
    }
  }
}
</script>

<style scoped lang="stylus">
@import '~quasar-variables';


>>>.q-tabs__arrow {
    padding-top:8px
}

</style>

